import { Routes } from '@angular/router';
import { LandingPageComponent } from './features/landing-page/landing-page.component';
import { IdVerificationComponent } from './features/check-in/components/id-verfication/id-verification.component';
import { termsRoutes } from './features/check-in/components/legal-acknowledgement-page/terms-routes';

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    data: { pageName: 'Landing Page' },
  },
  {
    path: 'id-verification',
    component: IdVerificationComponent,
    data: { pageName: 'ID Verification' },
  },
  ...termsRoutes,
  {
    path: 'signature-and-initials',
    loadComponent: () =>
      import(
        './features/signature-and-initials/signature-and-initials.component'
      ).then((m) => m.SignatureAndInitialsComponent),
    data: { pageName: 'Signature and Initials Creation' },
  },
  {
    path: 'signing-room',
    loadComponent: () =>
      import('./features/signing-room/signing-room.component').then(
        (m) => m.SigningRoomComponent,
      ),
    data: {
      footerType: 'compact',
      pageName: 'Document Signing Room',
      preload: true,
    },
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
    data: { pageName: 'Not Found' },
  },
  {
    path: 'session-end',
    loadComponent: () =>
      import('./features/session-end/session-end.component').then(
        (m) => m.SessionEndComponent,
      ),
    data: { pageName: 'Session End' },
  },
  {
    path: 'exit-signing',
    loadComponent: () =>
      import('./features/exit-signing/exit-signing.component').then(
        (m) => m.ExitSigningComponent,
      ),
    data: { exitSigningHeader: true },
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
    data: { pageName: 'Not Found' },
  },
];
